import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const BrandingWrapper = styled('div')<{ hasSubNav: boolean }>`
  background: ${({ theme }) => theme.color.white};
  position: relative;
  height: ${({ theme, hasSubNav }) =>
    hasSubNav ? theme.x7spacePx : theme.x8spacePx}px;
`;
export const ImageLogo = styled('img')<{ hasSubNav: boolean }>`
  height: ${({ theme, hasSubNav }) =>
    hasSubNav ? theme.x7spacePx : theme.x8spacePx}px;
  padding: ${({ theme }) =>
    `${theme.x1spacePx}px  0 ${theme.x1spacePx}px ${theme.x2spacePx}px`};
`;
export const SWSPoweredBy = styled('div')`
  text-align: center;
  padding: ${({ theme }) =>
    `${theme.x1spacePx - 2}px  ${theme.x3spacePx}px 0 0`};
`;
export const SWSLogoBlackWrapper = styled('div')`
  svg {
    width: 105px;
    height: 30px;
  }
`;

export const Wrapper = styled('div')<{ hasSubNav: boolean }>`
  background: ${({ theme }) => theme.color.noir};
  ${({ hasSubNav }) => {
    return (
      hasSubNav === false &&
      css`
        border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
      `
    );
  }}
  color: white;
  position: relative;
  text-align: center;
  width: 100%;
  height: ${({ theme, hasSubNav }) =>
    hasSubNav ? theme.x7spacePx : theme.x8spacePx}px;
  ${media.lgUp`
    display: none;
  `}
`;

export const MobileTopbarSearch = styled('div')<{ canGoBack: boolean }>`
  position: relative;
  height: ${({ theme }) => theme.x7spacePx}px;
  padding-top: 12px;
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
  padding-left: ${({ theme, canGoBack }) =>
    canGoBack ? theme.x13spacePx : theme.x8spacePx}px;
  padding-right: ${({ theme }) => theme.x8spacePx}px;
`;

export const SWSLogoWrapper = styled('div')<{ canGoBack: boolean }>`
  position: absolute;
  left: ${({ canGoBack, theme }) => (canGoBack ? theme.x5spacePx : 0)}px;
  top: 12px;
  overflow-x: hidden;
  a {
    display: block;
    width: 64px;
    height: 40px;
  }
  svg {
    width: 30px;
    height: 38px;
  }
`;

export const BackButton = styled('div')`
  position: absolute;
  left: 0;
  top: 12px;
  border-right: 1px solid ${({ theme }) => theme.color.darkerGray};
  > button {
    position: relative;
    padding: 0 12px;
    width: ${({ theme }) => theme.x5spacePx}px;
    height: ${({ theme }) => theme.x5spacePx}px;
    > svg {
      position: absolute;
      left: ${({ theme }) => theme.x1spacePx}px;
      top: ${({ theme }) => theme.x1spacePx}px;
      width: ${({ theme }) => theme.x3spacePx}px;
      height: ${({ theme }) => theme.x3spacePx}px;
      > * {
        fill: ${({ theme }) => theme.color.white};
      }
    }
  }
`;

export const User = styled('div')`
  position: absolute;
  right: 0;
  top: 12px;
`;
